import React from "react";
import { Routes, Route } from "react-router-dom";
import ForexCard from "./LandingPage/ForexCard";
import Home from "./LandingPage/Home";
import CurrencyExchange from "./LandingPage/CurrencyExchange";
import Faq from "./LandingPage/Faq";
import CorporateSolutions from "./LandingPage/CorporateSolutions";
import NimoRemittance from "./LandingPage/NimoRemittance";
import ContactUs from "./LandingPage/ContactUs";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/forex-cards" element={<ForexCard />} />
      <Route path="/exchange" element={<CurrencyExchange />} />
      <Route path="/nimo-remittance" element={<NimoRemittance />} />
      <Route path="/corporate-solutions" element={<CorporateSolutions />} />
      <Route path="/support" element={<ContactUs />} />
      <Route path="/faq" element={<Faq />} />
    </Routes>
  );
};

export default AppRouter;
